<template>
  <div>  

        <br />

        <v-container>
        <v-row>
            <v-col>
            <v-subheader><v-btn x-large color="primary" icon @click="$router.go(-1)"><v-icon>mdi-arrow-left</v-icon></v-btn> <h1 class="accent--text">Modifica cliente</h1></v-subheader>
            </v-col>
        </v-row>
        </v-container>
        <br />

        <v-card class="mx-auto" max-width="800" v-if="showForm">
            <v-card-title>
                Modifica cliente
            </v-card-title>
            <v-card-text>
                <v-form ref="form" v-model="form" lazy-validation>

                    <v-container>
                        <v-row>
                            <v-col cols="6">
                                <v-text-field v-model="values.name" label="Nome:" required></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <v-text-field v-model="values.surname" :rules="rules.required" label="Cognome*:" required></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-text-field v-model="values.email" :rules="rules.email" label="E-mail:"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6">
                                <v-text-field v-model="values.phone" :rules="rules.phone" label="Telefono:"></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <v-text-field v-model="values.cellphone" :rules="rules.phone" label="Cellulare:"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <h3>Tipologia cliente</h3>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-radio-group v-model="values.privateClient">
                                    <v-radio
                                        label="Privato"
                                        :value="1"
                                        color="green"
                                    ></v-radio>
                                    <v-radio
                                        label="Azienda"
                                        :value="0"
                                        color="green"
                                    ></v-radio>
                                    <v-radio
                                        label="Ente"
                                        :value="2"
                                        color="green"
                                    ></v-radio>
                                </v-radio-group>
                            </v-col>
                        </v-row>

                        <!-- Values private -->
                        <template v-if="values.privateClient == 1">
                            <v-row>
                                <v-col cols="6">
                                    <v-text-field v-model="values.fiscalCode" :rules="rules.required" label="CF (Codice fiscale)*:"></v-text-field>
                                </v-col>
                                <v-col cols="6">
                                    <v-text-field v-model="values.privateAddress" :rules="rules.required" label="Indirizzo residenza per fattura*:"></v-text-field>
                                </v-col>
                            </v-row>
                        </template>

                        <!-- Values business -->
                        <template v-if="values.privateClient != 1">
                            <v-row>
                                <v-col cols="6">
                                    <v-text-field v-model="values.businessName" :rules="rules.required" label="Ragione Sociale*:"></v-text-field>
                                </v-col>
                                <v-col cols="6">
                                    <v-text-field v-model="values.businessAddress" :rules="rules.required" label="Sede Legale*:"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="6">
                                    <v-text-field v-model="values.uniqueCode" label="Codice Univoco:"></v-text-field>
                                </v-col>
                                <v-col cols="6">
                                    <v-text-field v-model="values.pec" label="PEC:"></v-text-field>
                                </v-col>
                            </v-row>
                        </template>

						<!-- Confirmed -->
						<v-template v-if="$env.siteA">
							<v-col>
								<v-switch class="m-0" v-model="values.confirmed" color="success" label="Cliente attivo"></v-switch>
							</v-col>
						</v-template>

                    </v-container>

                    <h4>I campi contrassegnati * sono obbligatori.</h4>                   

                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-btn color="accent" @click="modify">Modifica cliente</v-btn>
            </v-card-actions>
        </v-card>

  </div>
</template>

<script>

export default {
  
  data() {
    return {

        rules: {
          required: [ value => (!value) ? 'Il campo non può essere vuoto.' : true ],
          email: [ value => (value && !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value)) ? 'Formato non valido' : true],
          phone: [ value => (value && !/^\d+$/.test(value)) ? 'Inserire i numeri senza spazi né caratteri speciali' : true],
        },

        form: false,
        showForm: true,
        values: {
            name: null,
            surname: null,
			confirmed: null,
            email: null,
            phone: null,
            cellphone: null,
            address: null,
            zip: null,
            city: null,
            province: null,
            privateClient: 1,
            // Private only
            fiscalCode: null,
            privateAddress: null,
            // Business only
            businessName: null,
            businessAddress: null,
            uniqueCode: null,
            pec: null,
        },
        currentClientId: null,
      
      }
  },

  methods: {

      getClient() {
        this.$emit('showProgress');
        this.$api.client.getFromId(this.currentClientId).then(data => {
            this.$emit('hideProgress');

            if (!data.ok) {
                this.$emit('showSnack', data.values.msg, 'error');
                return;
            }

            let client = data.values.client;

            console.log(client);

            // Ok
            this.values = {
                name: client.name,
                surname: client.surname,
				confirmed: parseInt(client.confirmed),
                email: client.email,
                phone: client.phone,
                cellphone: client.cellphone,
                address: client.address,
                zip: client.zip,
                city: client.city,
                province: client.province,
                privateClient: parseInt(client.private_client),
                // Private only
                fiscalCode: client.fiscal_code,
                privateAddress: client.private_address,
                // Business only
                businessName: client.business_name,
                businessAddress: client.business_address,
                uniqueCode: client.unique_code,
                pec: client.pec,
            }
        });  
      },

      modify() {
        
        if (!this.$refs.form.validate())
            return;

        // Send new info to database
        this.$emit('showProgress');
        this.$api.client.modifyClient(this.values, this.currentClientId).then(data => {
            this.$emit('hideProgress');

            if (!data.ok) {
                this.$emit('showSnack', 'Errore aggiornamento database', 'error');
                return;
            }

            // Ok
            this.$emit('showSnack', 'Informazione aggiornata correttamente', 'success');
        });
      },

  },

  watch: {

  },

  mounted() {
    this.currentClientId = this.$route.params.id; 
    this.getClient(this.currentClientId);
  },

}

</script>